import { css } from 'lit'
import { csColorFunctional } from '@cloudsuite/mosaic-shared/styles/colors.style.js'

export const fileUpload = css`
  .rma-file-upload__error {
    color: ${csColorFunctional.error};
  }
`
